var _a, _b;
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Text } from '@doordash/design-language';
import { IMAGE_BASE_URL, EXTERNAL_ROUTES } from '../../../constants/values';
import { PreviewVoucherRedemptionErrorCode, ClaimVoucherErrorCode, } from '../../../types/GloblalTypes';
import Button, { ButtonSize } from '@doordash/component-button';
import { FullScreenContainer, ContentWrapper, ImageWrapper, } from './VoucherErrorPageStyles';
import VoucherStrings from '../VoucherStrings';
import track from '../../../utils/track';
import { VoucherParticipantEvents } from '../../../constants/events/names';
import i18n from '../../../i18n';
var defaultVoucherErrorImgUrl = IMAGE_BASE_URL + "/s/managed/consumer/teams/voucher-errors.png";
var alreadyInAccountVoucherErrorImgUrl = IMAGE_BASE_URL + "/s/managed/consumer/teams/voucher-error-already-accepted.png";
var PreviewErrorDetails = (_a = {},
    _a[PreviewVoucherRedemptionErrorCode.UNSPECIFIED] = {
        title: i18n.t('vouchers_previewVoucherRedemptionErrorCode_unspecifiedTitle'),
        message: i18n.t('vouchers_previewVoucherRedemptionErrorCode_unspecifiedMessage'),
    },
    _a[PreviewVoucherRedemptionErrorCode.INVALID_VOUCHER] = {
        title: i18n.t('vouchers_previewVoucherRedemptionErrorCode_invalidVoucherTitle'),
        message: i18n.t('vouchers_previewVoucherRedemptionErrorCode_invalidVoucherMessage'),
    },
    _a[PreviewVoucherRedemptionErrorCode.ALREADY_ACCEPTED_VOUCHER] = {
        title: i18n.t('vouchers_previewVoucherRedemptionErrorCode_alreadyAcceptedVoucherTitle'),
        message: i18n.t('vouchers_previewVoucherRedemptionErrorCode_alreadyAcceptedVoucherMessage'),
        imgUrl: alreadyInAccountVoucherErrorImgUrl,
    },
    _a);
var ClaimErrorDetails = (_b = {},
    _b[ClaimVoucherErrorCode.ERROR_CODE_ACCOUNT_MEMBERSHIP_ISSUE] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_accountMembershipIssueTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_accountMembershipIssueMessage'),
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_ALREADY_IN_ANOTHER_TEAM] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_alreadyInAnotherTeamTitle'),
        message: function (existingTeamName) {
            return i18n.t('vouchers_claimVoucherErrorCode_alreadyInAnotherTeamMessage', {
                existingTeamName: existingTeamName,
            });
        },
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_ALREADY_IN_YOUR_ACCOUNT] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_alreadyInYourAccountTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_alreadyInYourAccountMessage'),
        imgUrl: alreadyInAccountVoucherErrorImgUrl,
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_ALREADY_REDEEMED] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_codeAlreadyRedeemedTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_codeAlreadyRedeemedMessage'),
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_EXPIRED_VOUCHER] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_expiredVoucherTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_expiredVoucherMessage'),
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_INACTIVE_TEAM_ACCOUNT] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_inactiveTeamAccountTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_inactiveTeamAccountMessage'),
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_INVALID_VOUCHER] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_invalidVoucherTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_invalidVoucherMessage'),
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_MAX_REDEEMED_NUMBER_REACHED] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_maxRedemedNumberReachedTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_maxRedemedNumberReachedMessage'),
    },
    _b[ClaimVoucherErrorCode.ERROR_CODE_UNSPECIFIED] = {
        title: i18n.t('vouchers_claimVoucherErrorCode_unspecifiedTitle'),
        message: i18n.t('vouchers_claimVoucherErrorCode_unspecifiedMessage'),
    },
    _b);
// surface a voucher error for both Preview Voucher page and Accept Voucher page
export var VoucherErrorPage = function (_a) {
    var error = _a.error;
    var budgetId = useParams().budgetId;
    var errCode = (error === null || error === void 0 ? void 0 : error.code) || PreviewVoucherRedemptionErrorCode.UNSPECIFIED;
    var errDetails = { title: '', message: '' };
    if (errCode === ClaimVoucherErrorCode.ERROR_CODE_ALREADY_IN_ANOTHER_TEAM) {
        errDetails = {
            title: ClaimErrorDetails[errCode].title,
            message: ClaimErrorDetails[errCode].message(error === null || error === void 0 ? void 0 : error.existingTeamName),
        };
    }
    else {
        errDetails =
            ClaimErrorDetails[errCode] ||
                PreviewErrorDetails[errCode] ||
                PreviewErrorDetails[PreviewVoucherRedemptionErrorCode.UNSPECIFIED];
    }
    React.useEffect(function () {
        track(VoucherParticipantEvents.RECIPIENT_FAILURE, {
            voucher_id: budgetId,
            error_code: errCode,
        });
    }, [budgetId, errCode]);
    return (React.createElement(FullScreenContainer, null,
        React.createElement(ContentWrapper, null,
            React.createElement(ImageWrapper, { src: errDetails.imgUrl || defaultVoucherErrorImgUrl }),
            React.createElement(Text, { styles: Text.Styles.NavBarExpandedTitle, textAlign: Text.TextAlignments.Center }, errDetails.title),
            React.createElement(Text, { styles: Text.Styles.Body1, textAlign: Text.TextAlignments.Center }, errDetails.message),
            React.createElement(Button, { accessibilityLabel: 'close', size: ButtonSize.Small, type: Button.Types.Tertiary, onClick: function () {
                    window.location.href = EXTERNAL_ROUTES.MARKETPLACE;
                } }, VoucherStrings.voucherErrorPage.closeButton()))));
};
export default VoucherErrorPage;
